export const BUSINESS_CARD_FIELDS = [
  'UserId',
  'Name',
  'Designation',
  'Email',
  'MobileNumber',
  'Status',
  'AppliedDateUtc',
  'ApprovedBy',
  'ApprovedByName',
  'ApprovedDateUtc',
  'ApprovalStatusReason',
  'DepartmentId',
  'Timezone',
] as const;
